/* eslint-disable @typescript-eslint/naming-convention */
'use client';

import { Locale } from '@core/Entities/Locale/Locale.entity';
import { Typography } from '@gds/Typography/Typography';
import { KenticoImage } from '@shared-components/KenticoImage/KenticoImage';
import { RichText } from '@page-builder/Components/RichText/RichText';
import { FinanceHelpModalContent, FinanceItem } from '../../../Entities/FinanceHelpModal.entity';
import { CalculatorMessages } from '../Calculator.messages';
import { financeHelpConfig, guideUrl, videoUrl } from './FinanceHelpModal.constants';
import styles from './FinanceHelpModal.module.css';
interface FinanceHelpModalProps {
  locale: Locale;
  financeMessages: FinanceHelpModalContent;
  financeModalStrings: CalculatorMessages;
}

export const FinanceHelpModal = ({
  financeMessages,
  financeModalStrings,
  locale,
}: FinanceHelpModalProps) => {
  const { financeItem, financeItemtwo, financeItemthree, financeItemfour } = financeMessages;
  const config = financeHelpConfig[locale];

  const renderFinanceItems = (financeItems: FinanceItem[]) => {
    return financeItems.map(item => (
      <li className={styles.uspItem} key={item.description}>
        <div className={styles.uspIcon}>
          <KenticoImage
            src={item.image[0]}
            alt={item.title}
            fill
            style={{ objectFit: 'contain' }}
            sizes="(max-width: 768px) 20vw, (max-width: 1200px) 33vw"
          />
        </div>
        <div>{item.description}</div>
      </li>
    ));
  };

  return (
    <div className={styles.financeModal}>
      <div className={styles.financeModalDescription}>
        <RichText noPadding richText={financeMessages.header} />
      </div>

      <div className={styles.financeModalContent}>
        <div className={styles.financeModalOption}>
          <div className={styles.financeModalOptionTitle}>
            <Typography variant="h5" Component="span">
              {financeMessages.subheader}
            </Typography>
          </div>
          <div className={styles.financeModalOptionSubtitle}>
            <Typography variant="body3" Component="span">
              {financeMessages.description}
            </Typography>
          </div>
          {config.showFinanceUsp && (
            <div className={styles.financeModalUspsWrapper}>{renderFinanceItems(financeItem)}</div>
          )}

          {(config.showPaymentPlanText || config.showPaymentPlanImage) && (
            <div className={styles.financeModalPaymentPlan}>
              {config.showPaymentPlanImage && (
                <>
                  <Typography variant="subheading3">{financeModalStrings.paymentPlan}</Typography>
                  <div className={styles.financeModalImage}>
                    <KenticoImage src={financeMessages.image[0]} alt="car" fill />
                  </div>
                </>
              )}
              {config.showPaymentPlanText && (
                <>
                  <Typography variant="subheading3">{financeMessages.bodytitle}</Typography>
                  <div className={styles.financeModalUspsWrapper}>
                    {renderFinanceItems(financeItemthree)}
                  </div>
                </>
              )}
            </div>
          )}

          {config.showPcpGuide && (
            <div className={styles.financeModalLinksFooter}>
              <a
                href={videoUrl.pcp}
                className={styles.financeModalGuideLinks}
                target="_blank"
                rel="noreferrer"
              >
                <Typography variant="body2" Component="span">
                  {financeModalStrings.pcpFilm}
                </Typography>
              </a>
              <a
                href={guideUrl.pcp}
                className={styles.financeModalGuideLinks}
                target="_blank"
                rel="noreferrer"
              >
                <Typography variant="body2" Component="span">
                  {financeModalStrings.pcpGuide}
                </Typography>
              </a>
            </div>
          )}
        </div>

        <div className={styles.financeModalOption}>
          <div className={styles.financeModalOptionTitle}>
            <Typography variant="h5" Component="span">
              {financeMessages.subheadertwo}
            </Typography>
          </div>
          <div className={styles.financeModalOptionSubtitle}>
            <Typography variant="body3" Component="span">
              {financeMessages.descriptiontwo}
            </Typography>
          </div>

          {config.showFinanceUsp && (
            <div className={styles.financeModalUspsWrapper}>
              {renderFinanceItems(financeItemtwo)}
            </div>
          )}

          {(config.showPaymentPlanText || config.showPaymentPlanImage) && (
            <div className={styles.financeModalPaymentPlan}>
              {config.showPaymentPlanImage && (
                <>
                  <Typography variant="subheading3">{financeModalStrings.paymentPlan}</Typography>
                  <div className={styles.financeModalImage}>
                    <KenticoImage src={financeMessages.imagehp[0]} alt="car" fill />
                  </div>
                </>
              )}

              {config.showPaymentPlanText && (
                <>
                  <Typography variant="subheading3">{financeMessages.bodytitle}</Typography>
                  <div className={styles.financeModalUspsWrapper}>
                    {renderFinanceItems(financeItemfour)}
                  </div>
                </>
              )}
            </div>
          )}
          {config.showHPGuide && (
            <div className={styles.financeModalLinksFooter}>
              <a
                href={videoUrl.hp}
                className={styles.financeModalGuideLinks}
                target="_blank"
                rel="noreferrer"
              >
                <Typography variant="body2" Component="span">
                  {financeModalStrings.hpFilm}
                </Typography>
              </a>
              <a
                href={guideUrl.hp}
                className={styles.financeModalGuideLinks}
                target="_blank"
                rel="noreferrer"
              >
                <Typography variant="body2" Component="span">
                  {financeModalStrings.hpGuide}
                </Typography>
              </a>
            </div>
          )}
        </div>
      </div>
      <div className={styles.financeModalFooter}>
        <Typography variant="caption2" Component="span">
          {financeModalStrings.dealership}
        </Typography>
      </div>
    </div>
  );
};
